<template>
  <div class="rmr-page-shell">
    <rmr-page-hero
      title="Demande"
      title-accent="d'ajout de sources"
      subtitle="Proposez des sites, flux ou comptes à suivre : chaque URL est vérifiée, puis la source est créée sur le site choisi."
      :icon="icons.mdiRssBox"
    />

    <section class="rmr-page-shell__content srq-page__content">
      <v-card flat class="rmr-table-shell">
        <div class="rmr-table-shell__header">
          <div class="rmr-table-shell__topline">
            <div class="rmr-table-shell__heading">
              <div class="rmr-table-shell__eyebrow">News Radar</div>
              <div class="rmr-table-shell__title">Nouvelle demande</div>
            </div>
          </div>
        </div>
        <v-card-text class="rmr-table-shell__body">
          <source-request-form
            ref="form"
            @created="handleCreated"
            @error="handleError"
          />
        </v-card-text>
      </v-card>

      <source-request-history ref="history" @settled="handleSettled" />
    </section>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.status"
      :timeout="snackbar.timeout"
      top
    >
      {{ snackbar.message }}
    </v-snackbar>
  </div>
</template>

<script>
import { onMounted, reactive } from "@vue/composition-api";
import { mdiRssBox } from "@mdi/js";

import SourceRequestForm from "@/components/news-radar/source-request/SourceRequestForm.vue";
import SourceRequestHistory from "@/components/news-radar/source-request/SourceRequestHistory.vue";
import RmrPageHero from "@/components/ui/layout/RmrPageHero.vue";

import useProxy from "@/hooks/useProxy";
import { saveRmraView } from "@/utils/rmr-analytics";

export default {
  name: "NewsradarSourceRequest",
  components: {
    RmrPageHero,
    SourceRequestForm,
    SourceRequestHistory,
  },
  setup() {
    const { refs, route } = useProxy();

    const snackbar = reactive({
      show: false,
      message: "",
      status: "success", // success|error|warning
      timeout: 6000,
    });

    // =>  METHODS
    const notify = (message, status = "success") => {
      snackbar.message = message;
      snackbar.status = status;
      snackbar.show = true;
    };

    // La pré-validation (URL invalide, doublon, déjà suivie) est immédiate :
    // on le dit tout de suite, le reste se lit dans l'historique.
    const handleCreated = (request) => {
      const pending = request.total - request.rejected_count;
      const details = [];
      if (pending) {
        details.push(`${pending} URL à vérifier`);
      }
      if (request.rejected_count) {
        const plural = request.rejected_count > 1 ? "s" : "";
        details.push(`${request.rejected_count} refusée${plural} d'emblée`);
      }
      notify(
        `Demande #${request.id} enregistrée — ${details.join(", ")}`,
        pending ? "success" : "warning"
      );
      if (refs.history) {
        refs.history.refresh(request);
      }
    };

    const handleSettled = () => {
      if (refs.form) {
        refs.form.loadQuota();
      }
    };

    const handleError = (message) => notify(message, "error");

    // =>  HOOKS
    onMounted(() => {
      saveRmraView(route);
    });

    // =>  DATA
    return {
      handleCreated,
      handleError,
      handleSettled,
      icons: { mdiRssBox },
      snackbar,
    };
  },
};
</script>

<style lang="scss" scoped>
.srq-page__content {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
</style>
